import { Reveal } from "./Reveal";
import { VALUES } from "./data";

export const Values = () => (
  <section id="values" aria-labelledby="values-heading" data-testid="values-section" className="py-16 md:py-24 bg-white">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <Reveal>
        <div className="max-w-2xl mb-12">
          <span className="text-sm font-bold uppercase tracking-wide text-brand-accentink">What we stand for</span>
          <h2 id="values-heading" className="mt-3 font-heading font-extrabold tracking-tight text-3xl md:text-4xl text-brand-blue">
            Care · People · Home
          </h2>
        </div>
      </Reveal>
      <div className="grid md:grid-cols-3 gap-6">
        {VALUES.map((v, i) => (
          <Reveal key={v.id} delay={0.08 * i}>
            <div data-testid={`value-card-${v.id}`} className="h-full rounded-3xl border border-brand-line bg-brand-cream p-8 shadow-[0_12px_36px_rgba(2,71,157,0.06)] hover:shadow-[0_20px_40px_rgba(2,71,157,0.12)] hover:-translate-y-1 transition-all duration-300">
              <span className="grid place-items-center h-14 w-14 rounded-2xl bg-brand-green/15 text-brand-accentink">
                <v.icon className="h-7 w-7" strokeWidth={2} aria-hidden="true" />
              </span>
              <h3 className="mt-5 text-xl md:text-2xl font-heading font-bold text-brand-ink">{v.title}</h3>
              <p className="mt-3 text-base text-brand-ink2 leading-relaxed">{v.body}</p>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
